import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import {
  DEFAULT_DIMENSIONS_DASHBOARD_ID,
  DEFAULT_TILES_DIMENSIONS_FILTER_ID,
} from "@/api/dimensions/constants";
import { LoadingFallback } from "@/components/LoadingFallback";
import { DimensionsOmniIframe } from "@/features/Dimensions/DimensionsOmniIframe";

const dimensionsSearchSchema = z.object({
  tabId: z
    .string()
    .optional()
    .transform((value) =>
      value !== undefined && value.length > 0 ? value : undefined,
    ),
});

export const Route = createFileRoute("/_auth/dimensions/$siteId/")({
  component: RouteComponent,
  pendingComponent: LoadingFallback,
  validateSearch: zodValidator(dimensionsSearchSchema),
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const { tabId } = Route.useSearch();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <DimensionsOmniIframe
        siteId={siteId}
        dashboardId={DEFAULT_DIMENSIONS_DASHBOARD_ID}
        filterId={DEFAULT_TILES_DIMENSIONS_FILTER_ID}
        tabId={tabId}
        title="Dimensions Dashboard"
      />
    </Box>
  );
}
